import { render } from "./ProjectFileContent.vue?vue&type=template&id=4a835578&scoped=true"
import script from "./ProjectFileContent.vue?vue&type=script&lang=js"
export * from "./ProjectFileContent.vue?vue&type=script&lang=js"

import "./ProjectFileContent.vue?vue&type=style&index=0&id=4a835578&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a835578"]])

export default __exports__